import { render } from "./ProjectBox.vue?vue&type=template&id=49ba6186"
import script from "./ProjectBox.vue?vue&type=script&lang=js"
export * from "./ProjectBox.vue?vue&type=script&lang=js"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__